const QUOTES = [
  {
    quote:
      "When our association was faced with an unexpected ADA website demand letter, we didn't know where to turn. Association Integrity responded immediately and remediated our website within days. Their fast, professional approach helped us address the issue efficiently and move forward with confidence.",
    name: "Margaret Ellsworth",
    role: "Board President",
    org: "Coral Ridge Towers Condominium · Fort Lauderdale",
    image:
      "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20confident%2065%20year%20old%20woman%20with%20silver%20hair%20wearing%20elegant%20cream%20blouse%20smiling%20warmly%20against%20soft%20neutral%20studio%20background%2C%20natural%20lighting%2C%20refined%20editorial%20headshot%20photography%2C%20warm%20muted%20tones&width=200&height=200&seq=quote-margaret-01&orientation=squarish",
  },
  {
    quote:
      "Our 55+ community needed help keeping up with evolving compliance requirements. Association Integrity updated our existing HOA website, guided us through the compliance process, and addressed the key documentation and accessibility requirements. Their knowledgeable team made the entire experience straightforward and stress-free, giving our board confidence that our community was on the right track.",
    name: "Robert Chen",
    role: "General Manager",
    org: "Kings Point Sunrise · Delray Beach",
    image:
      "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20confident%2055%20year%20old%20asian%20american%20man%20wearing%20navy%20blazer%20and%20white%20shirt%20smiling%20naturally%20against%20soft%20neutral%20studio%20background%2C%20warm%20studio%20lighting%2C%20refined%20editorial%20corporate%20headshot%20photography&width=200&height=200&seq=quote-robert-02&orientation=squarish",
  },
  {
    quote:
      "Managing multiple communities means staying ahead of changing compliance requirements can be challenging. Association Integrity provides a trusted resource to help identify concerns, organize documentation, and keep compliance information ready for board review. Having a dedicated partner to support the process brings greater confidence and peace of mind.",
    name: "Alicia Ramirez, CAM",
    role: "Regional Property Manager",
    org: "Seabreeze Community Management · Boca Raton",
    image:
      "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20confident%2040%20year%20old%20latina%20woman%20with%20dark%20wavy%20hair%20wearing%20terracotta%20blouse%20smiling%20warmly%20against%20soft%20neutral%20studio%20background%2C%20natural%20lighting%2C%20refined%20editorial%20corporate%20headshot%20photography%2C%20warm%20muted%20tones&width=200&height=200&seq=quote-alicia-03&orientation=squarish",
  },
];

export default function Testimonials() {
  return (
    <section className="py-24 md:py-32 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-14">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-primary-700 font-semibold">
            <i className="ri-double-quotes-l" />
            Board rooms talking
          </span>
          <h2 className="mt-4 font-heading text-4xl md:text-5xl font-semibold text-foreground-950 leading-[1.05]">
            Peace of mind, entered into the minutes.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {QUOTES.map((q, idx) => (
            <figure
              key={q.name}
              className={`rounded-lg p-8 border ${
                idx === 1
                  ? "bg-secondary-100 border-secondary-200"
                  : "bg-background-100 border-background-200"
              }`}
            >
              <i className="ri-double-quotes-l text-primary-500 text-3xl" />
              <blockquote
                className="mt-4 text-foreground-800 text-base leading-relaxed font-heading italic"
                dangerouslySetInnerHTML={{ __html: `&ldquo;${q.quote}&rdquo;` }}
              />
              <figcaption className="mt-6 flex items-center gap-3 pt-6 border-t border-background-200">
                <img
                  src={q.image}
                  alt={q.name}
                  className="w-12 h-12 rounded-full object-cover object-top"
                />
                <div>
                  <div className="font-heading font-semibold text-foreground-950 text-sm">
                    {q.name}
                  </div>
                  <div className="text-xs text-foreground-600">{q.role}</div>
                  <div className="text-xs text-foreground-500">{q.org}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}